import { ValidatorConstraintInterface, ValidatorConstraint } from 'class-validator';
import { GoTemplateRegEx } from './goTemplateValidator';
import validator from 'validator';

@ValidatorConstraint({ name: 'IsUrlOrUrlTemplate' })
export class IsUrlOrUrlTemplateValid implements ValidatorConstraintInterface {
  validate(currentValue: string) {
    const url = currentValue.replace(GoTemplateRegEx, 'str');
    return validator.isURL(url, { require_tld: false });
  }

  defaultMessage() {
    return 'Please enter a valid URL';
  }
}
